<template>
  <TextFormField :label="label" :id="id" :errors="errors" :icon="icon" :name="name" :modelValue="modelValue.number" @update:modelValue="onNumberUpdate">
    <template v-slot:before>
      <div class="select-container">
        <span class="prefix">+</span>
        <select v-bind:preventFocusShift="true" :value="modelValue.countryCallingCode" @input="onCountryCallingCodeUpdate($event.target.value)">
          <option v-for="c in countries" :value="c.countryCallingCode">
            {{ c.countryCallingCode }}
          </option>
        </select>
        <div class="caret" v-bind:preventFocusShift="true"></div>
      </div>
    </template>
  </TextFormField>
</template>
<script>

import TextFormField from './TextFormField.vue';
import { all } from 'country-codes-list'

export default {
  name: 'TelFormField',
  components: {
    TextFormField
  },
  props: {
    label: {
      type: String,
      required: true
    },
    errors: {
      type: [Array, null, undefined],
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: 'form-phone'
    },
    modelValue: {
      required: true,
      type: Object,
      default: {
        number: null,
        countryCallingCode: null
      }
    },
    type: {
      type: String,
      default: 'tel'
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    const euCountryCodes = [
      'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR',
      'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO',
      'SE', 'SI', 'SK'
    ];
    return {
      countries: all().filter(country => euCountryCodes.includes(country.countryCode))
                     .sort((a, b) => parseInt(a.countryCallingCode) - parseInt(b.countryCallingCode))
    }
  },
  methods: {
    onNumberUpdate(number) {
      this.modelValue.number = number
      this.$emit('update:modelValue', this.modelValue)
    },
    onCountryCallingCodeUpdate(ccc) {
      this.modelValue.countryCallingCode = ccc
      this.$emit('update:modelValue', this.modelValue)
    },
  }
}
</script>